import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("ac_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

let refreshing = null;
api.interceptors.response.use((r) => r, async (err) => {
  const cfg = err.config || {};
  if (err.response?.status !== 401 || cfg._retry || /^\/auth\/(login|register|refresh|logout|supplier-apply)/.test(cfg.url || "")) return Promise.reject(err);
  cfg._retry = true;
  try {
    refreshing = refreshing || axios.post(`${API}/auth/refresh`, { refresh_token: localStorage.getItem("ac_refresh") }, { withCredentials: true });
    const { data } = await refreshing;
    localStorage.setItem("ac_token", data.token);
    localStorage.setItem("ac_refresh", data.refresh_token);
    return api(cfg);
  } catch {
    localStorage.removeItem("ac_token");
    localStorage.removeItem("ac_refresh");
    window.dispatchEvent(new Event("ac-logout"));
    return Promise.reject(err);
  } finally {
    refreshing = null;
  }
});

export function errMsg(e) {
  if (e?.message === "Network Error" || e?.code === "ERR_NETWORK") return "Can't reach HostAfricair right now. Check your connection and try again.";
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function money(amount, currency) {
  if (amount == null) return "—";
  const digits = Math.abs(amount) >= 100 ? 0 : 2;
  try {
    return new Intl.NumberFormat("en", {
      style: "currency", currency, maximumFractionDigits: digits, minimumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `${currency} ${Number(amount).toLocaleString()}`;
  }
}

export const flag = (code) => `https://flagcdn.com/w40/${code.toLowerCase()}.png`;

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");

export const TECH = {
  fibre: { label: "Fibre", path: "/internet/fibre" },
  "5g": { label: "Fixed 5G", path: "/internet/5g" },
  lte: { label: "LTE", path: "/internet/lte" },
  hosting: { label: "Hosting", path: "/hosting" },
};

export const STATUS_LABEL = {
  paid: "Paid", pending_supplier: "With supplier", accepted: "Accepted",
  installation_scheduled: "Installation scheduled", active: "Active", rejected: "Rejected",
  cancelled: "Cancelled", failed: "Failed", retry: "Retried", pending_payment: "Awaiting payment",
  payment_failed: "Payment failed", pending: "Pending", approved: "Approved", suspended: "Suspended",
  unpaid: "Unpaid", draft: "Draft", published: "Published", open: "Open", answered: "Answered", closed: "Closed", registered: "Registered",
};
